import React, { useEffect, useState } from 'react';
import useActiveTabFlag from '@utils/hooks/useActiveTabFlag';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const rollingText = [
  '인사담당자에게 전달되니 단정하고 깔끔한 모습으로 응시한다면 제안받을 확률이 높아집니다.',
  '분석이 끝나면 카카오톡 메시지를 보내드려요. (최대 1일 소요)',
  '여러 기업에 지원할 경우, 잡다에 저장된 역검을 제출할 수 있어요.',
  '결과에 따라 취업에 활용할 수 있도록 면접 가이드를 제공해드려요.',
];

const ANGLE = 360 / rollingText.length;

const TipList = () => {
  const [rotateX, setRotateX] = useState(0);
  const initFlag = useActiveTabFlag();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRotateX((prev) => prev - ANGLE);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  if (!initFlag) return null;

  return (
    <div className={cx('tipArea')}>
      <div className={cx('title')}>TIP</div>
      <div className={cx('rotatorArea')}>
        <div
          className={cx('rotator')}
          style={{
            transform: `rotateX(${rotateX}deg)`,
          }}
        >
          {rollingText.map((text, idx) => (
            <div key={idx} className={cx('item')} style={{ transform: `rotateX(${idx * ANGLE}deg) translateZ(50px)` }}>
              {text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TipList;
